import _ from 'lodash';

function dashValue(elem) {
  const $elem = $(elem);
  if (!$elem.val() || $elem.val() === '00:00') {
    $elem.val('-');
  }
}

function onFormChange(elem) {
  $(elem).parents('#schedule-form').data('changed', true);
}

function onTimepickerValueChange(elem) {
  onFormChange(elem);
  dashValue(elem);
}

$(document).on('ready turbolinks:load', () => {
  const $timepickers = $('form.edit_school, form.edit_klass').find('.table-schedule .timepicker-field');

  $timepickers.each((index, elem) => dashValue(elem));
  $timepickers.off('dp.change dp.hide dp.show').on('dp.change dp.hide dp.show', ({ currentTarget }) => onTimepickerValueChange(currentTarget));

  _($('#schedule-form .ms-ctn.form-control'))
    .map(elem => $(elem).data('magicSuggest'))
    .forEach(ms => $(ms).off('selectionchange.schedules').on('selectionchange.schedules', ({ currentTarget: { container } }) => onFormChange(container)));
});
